import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {FullScreeen} from '../widget/sharedPage.styles';
import {formFields} from '../../../assets/data/survey/survey-form-field';
import {FormContainer} from '../../../components/PatientSurvey/PatientSurvey.styles';
import {useTranslation} from 'react-i18next';
import useFormField from '../../../hooks/useFormField';
import {createSurvey, getPatientByToken, submitSurveyWithToken} from "../../../utils/api-lists/patient.api";
import StandaloneHeaderComponent from "../../../components/StandaloneHeader/standalone-header.component";
import {CalendarOutlined, ContainerOutlined, PlusOutlined} from "@ant-design/icons";
import {Button, Checkbox, Drawer, Modal, Space, Tag} from "antd";
import SurveyFaceCameraDrawer from '../../../components/Camera/SurveyFaceCameraDrawer';
import SurveyFormsComponent from "./survey-forms.component";
import './patient_survey.css';
import PhotosMedia from "../../../assets/visual_analysis.png";
import PlaceholderView from "../../PatientCabinet/components/PlaceholderView";
import CameraInstructionsModal from "../../../components/CameraInstructionsModal/CameraInstructionsModal";
import { set } from 'date-fns';

import MobilePicture from '../../../assets/evidence.png'

const PatientSurveySubmitShareNewDesign = () => {
    const {t} = useTranslation("common");
    const location = useLocation();
    const navigate = useNavigate();

    const [isSent, setIsSent] = useState(false);
    const [cameraVisible, setCameraVisible] = useState(false);
    const [mediaFiles, setMediaFiles] = useState([]); // Changed from images to mediaFiles
    const [cameraModalVisible, setCameraModalVisible] = useState(false);
    const [cameraDrawerVisible, setCameraDrawerVisible] = useState(false);
    const [faceCameraDrawerVisible, setFaceCameraDrawerVisible] = useState(false);
    const [faceCameraMode, setFaceCameraMode] = useState('photo');
    const [visualMediaDrawerVisible, setVisualMediaDrawerVisible] = useState(false);
    const [openTermsAndConditions, setOpenTermsAndConditions] = useState(false);
    const [showCameraInstructions, setShowCameraInstructions] = useState(false);
    const [pendingCameraMode, setPendingCameraMode] = useState(null);
    const [consentProductImprovement, setConsentProductImprovement] = useState(false);
    const [consentResearch, setConsentResearch] = useState(false);
    const [consentMarketing, setConsentMarketing] = useState(false);
    const [consentAgeTerms, setConsentAgeTerms] = useState(false);
    const [consentExplicitFacial, setConsentExplicitFacial] = useState(false);
    const [mobilWarningModalVisible, setMobilWarningModalVisible] = useState(false);


    const queryParams = new URLSearchParams(location.search);
    const patientId = queryParams.get('patientId');
    const doctorId = queryParams.get('doctorId');
    const token = queryParams.get('token');
    const [patientData, setPatientData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: ''
    });
    const [openLifeStyle, setOpenLifeStyle] = useState(false);

    const [alert, setAlert] = useState({message: null, type: null});

    const initialValues = formFields.reduce((acc, field) => {
        acc[field.name] = field.type === "multi-select" || field.type === "creatable-multi-select" ? [] : "";
        return acc
    }, {});

    useEffect(() => {
      getPatientData();
    }, [token]);

    useEffect(() => {
      const handleResize = () => {
        setMobilWarningModalVisible(window.innerWidth >= 768);
      };

      handleResize(); // check on first load
      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }, []);


    const getPatientData = async () => {
        if (token) {
            try {
                const data = await getPatientByToken(token);
                setPatientData(data);
            } catch (error) {
                console.error("Error fetching patient data:", error);
            }
        }
    }

    const validateForm = (formData) => {
        let errors = {};

        formFields.forEach((field) => {
            if (
                field.required &&
                (!formData[field.name] ||
                    (Array.isArray(formData[field.name]) &&
                        formData[field.name].length === 0))
            ) {
                errors[field.name] = `${field.label} is required`;
            }
        });

        return errors;
    };

    const handleAddMedia = (file) => {
        setMediaFiles(prev => [...prev, file]);
    };

    const handleRemoveMedia = (index) => {
        setMediaFiles(prev => prev.filter((_, i) => i !== index));
    };

    const isVideoFile = (file) => {
        return file.type.startsWith('video/');
    };

    const onSave = async () => {
        setIsSent(true);
        try {
            if (token) {
                const formData = new FormData();
                formData.append('survey_response', JSON.stringify(formDataState));
                mediaFiles.forEach((file, idx) => {
                    const fieldName = isVideoFile(file) ? `videos[${idx}]` : `images[${idx}]`;
                    formData.append(fieldName, file, file.name);
                });
                // Only append marketing_consent if consentMarketing is true
                if (consentMarketing) {
                    formData.append('marketing_consent', 'true');
                }
                await submitSurveyWithToken(token, formData);
            } else {
                await createSurvey(patientId, doctorId, formDataState);
            }
            navigate('/standalone/survey-status', {state: {status: 'success'}});
        } catch (error) {
            console.error("Error submitting survey:", error);
            navigate('/standalone/survey-status', {state: {status: 'error', message: 'Failed to send your Survey'}});
            setIsSent(false);
        }
    };

    const onCloseLifeStyle = () => {
        setOpenLifeStyle(false);
    };

    const handleCameraCapture = (media) => {
        // media can be a base64 image or a video blob
        if (typeof media === 'string') {
            // base64 image, convert to File (always save as jpg)
            const arr = media.split(','), bstr = atob(arr[1]), n = bstr.length,
                u8arr = new Uint8Array(n);
            for (let i = 0; i < n; ++i) {
                u8arr[i] = bstr.charCodeAt(i);
            }
            const file = new File([u8arr], `photo_${Date.now()}.jpg`, {type: 'image/jpeg'});
            handleAddMedia(file);
        } else if (media instanceof Blob) {
            const file = new File([media], `video_${Date.now()}.webm`, {type: media.type});
            handleAddMedia(file);
        }
        setCameraDrawerVisible(false);
    };

    const handleFaceCameraCapture = (file) => {
        handleAddMedia(file);
        setFaceCameraDrawerVisible(false);
    };

    const {
        formData: formDataState,
        formErrors,
        handleInputChange,
        handleReactSelectChange,
        handleReactMultiSelectChange,
        handleSubmit,
    } = useFormField(initialValues, validateForm, formFields);


    return (
      <FullScreeen style={{ minHeight: "100vh" }}>
        <StandaloneHeaderComponent />
        <FormContainer
          style={{ paddingLeft: "2rem", paddingRight: "2rem", gap: "2rem" }}
        >
          <h2 className="text-xl font-semibold">
            Start Your Glacies Skin Health Journey
          </h2>
          <div
            style={{
              stroke: "#3F374B",
              backgroundColor: "#2B2238",
              padding: "20px",
              borderRadius: "12px",
              maxWidth: "600px",
              border: "1px solid #3F374B",
              width: "100%",
            }}
          >
            <div className="flex flex-col">
              <h2 className="text-xl font-semibold text-white mb-4">
                {"Skincare Professional Information"}
              </h2>
              <div className="flex flex-col sm:flex-row gap-3">
                <div>
                  <p className="text-gray-400 text-sm mb-1">Name</p>
                  <p className="text-white">{`${patientData.first_name} ${patientData.last_name}`}</p>
                </div>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Phone</p>
                  <p className="text-white">{patientData.phone}</p>
                </div>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Email</p>
                  <p className="text-white">{patientData.email}</p>
                </div>
              </div>
            </div>
          </div>
          <h2 className="text-xl font-semibold">Skin Health Steps</h2>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              width: "100%",
              alignItems: "center",
            }}
          >
            <div
              style={{
                stroke: "#3F374B",
                backgroundColor: "#2B2238",
                padding: "20px",
                borderRadius: "12px",
                maxWidth: "600px",
                border: "1px solid #3F374B",
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexDirection: "row",
              }}
              onClick={() => setOpenLifeStyle(true)}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "12px",
                  backgroundColor: "#1E3A8A",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <CalendarOutlined />
              </div>
              <p style={{ flexGrow: 1 }}>{t("lifeStyle")}</p>
              <Tag color="#1E3A8A">Step 1</Tag>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  border: "2px dashed #2563EB",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <PlusOutlined style={{ color: "#60A5FA" }} />
              </div>
            </div>
            <div
              style={{
                stroke: "#3F374B",
                backgroundColor: "#2B2238",
                padding: "20px",
                borderRadius: "12px",
                maxWidth: "600px",
                border: "1px solid #3F374B",
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexDirection: "row",
              }}
              onClick={() => setVisualMediaDrawerVisible(true)}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "12px",
                  backgroundColor: "#581C87",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <ContainerOutlined />
              </div>
              <p style={{ flexGrow: 1 }}>{t("visual_analysis")}</p>
              <Tag color="#581C87">Step 2</Tag>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  border: "2px dashed #9333EA",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <PlusOutlined style={{ color: "#C084FC" }} />
              </div>
            </div>
          </div>
        </FormContainer>
        <div
          style={{
            flexGrow: 1,
          }}
        ></div>
        <div
          style={{
            width: "100%",
            display: "flex",
            gap: "0.5rem",
            justifyContent: "space-around",
            padding: "0.5rem",
          }}
        >
          <Button
            type="default"
            size="large"
            style={{ width: "100%" }}
            onClick={() =>
              navigate("/standalone/survey-status", {
                state: { status: "cancel" },
              })
            }
          >
            Cancel
          </Button>
          <Button
            type="primary"
            size="large"
            style={{
              width: "100%",
            }}
            onClick={onSave}
            loading={isSent}
          >
            Submit
          </Button>
        </div>
        <Drawer
          title={t("lifeStyle")}
          placement="bottom"
          height={"90%"}
          onClose={onCloseLifeStyle}
          open={openLifeStyle}
          extra={
            <Space>
              <Button type="primary" onClick={onCloseLifeStyle}>
                Save
              </Button>
            </Space>
          }
        >
          <SurveyFormsComponent
            formData={formDataState}
            formErrors={formErrors}
            handleInputChange={handleInputChange}
            handleReactSelectChange={handleReactSelectChange}
            handleReactMultiSelectChange={handleReactMultiSelectChange}
          />
        </Drawer>
        <Drawer
          title={t("visual_analysis")}
          placement="bottom"
          height={"100%"}
          onClose={() => setVisualMediaDrawerVisible(false)}
          open={visualMediaDrawerVisible}
          extra={
            <div style={{ display: "flex", gap: 8 }}>
              <Button
                type="primary"
                onClick={() => {
                  setPendingCameraMode("photo");
                  setShowCameraInstructions(true);
                }}
              >
                Add Image
              </Button>
              <Button
                onClick={() => {
                  setPendingCameraMode("video");
                  setShowCameraInstructions(true);
                }}
              >
                Add Video
              </Button>
            </div>
          }
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 16,
              marginBottom: 24,
            }}
          >
            {mediaFiles.length === 0 && (
              <div className="w-full">
                <PlaceholderView
                  image={PhotosMedia}
                  title={t("no_media_files_yet")}
                  description={t("upload_photo_description")}
                  buttonText={t("upload_now")}
                  onButtonClick={() => {
                    setFaceCameraMode("video");
                    setPendingCameraMode("video");
                    setShowCameraInstructions(true);
                  }}
                />
              </div>
            )}
            {mediaFiles.map((file, idx) => (
              <div
                key={idx}
                style={{ position: "relative", width: 120, height: 120 }}
              >
                {isVideoFile(file) ? (
                  <video
                    src={URL.createObjectURL(file)}
                    style={{
                      width: 120,
                      height: 120,
                      objectFit: "cover",
                      borderRadius: 8,
                      border: "2px solid #eee",
                    }}
                    controls
                  />
                ) : (
                  <img
                    src={URL.createObjectURL(file)}
                    alt={`face-media-${idx}`}
                    style={{
                      width: 120,
                      height: 120,
                      objectFit: "cover",
                      borderRadius: 8,
                      border: "2px solid #eee",
                    }}
                  />
                )}
                <Button
                  size="small"
                  danger
                  style={{ position: "absolute", top: 2, right: 2 }}
                  onClick={() => handleRemoveMedia(idx)}
                >
                  X
                </Button>
              </div>
            ))}
          </div>
          {/*    Add button here to save after 1 image or video uploaded*/}

          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              position: "absolute",
              width: "100%",
              bottom: 24,
              left: 0,
            }}
          >
            <Button
              type="primary"
              style={{ width: "100%", maxWidth: "200px" }}
              disabled={mediaFiles.length === 0}
              onClick={() => setVisualMediaDrawerVisible(false)}
            >
              Save
            </Button>
          </div>
        </Drawer>
        <SurveyFaceCameraDrawer
          visible={faceCameraDrawerVisible}
          onClose={() => setFaceCameraDrawerVisible(false)}
          onCapture={handleFaceCameraCapture}
          height="100%"
          mode={faceCameraMode}
        />
        <Modal
          title={t("device_recommendation_title")}
          open={mobilWarningModalVisible}
          className="custom-dark-modal"
          onCancel={() => {
            setMobilWarningModalVisible(false);
            setOpenTermsAndConditions(true);
          }}
          centered
          onOk={() => {
            setMobilWarningModalVisible(false);
            setOpenTermsAndConditions(true);
          }}
          okText="OK"
            cancelButtonProps={{ style: { display: "none" } }} // hides Cancel
          width="45%"
        >
          <p
            style={{
              fontSize: "16px",
              textAlign: "center",
              marginTop: "2rem",
              marginBottom: "2rem",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "1rem",
              }}
            >
              <img
                src={MobilePicture}
                alt="mobile"
                style={{ width: "200px", height: "200px" }}
              />
            </div>{" "}
            {t("device_recommendation_line_1")}
            <br />
            {t("device_recommendation_line_2")}
          </p>
        </Modal>

        <Modal
          title="Terms and Conditions"
          centered
          className="custom-dark-modal"
          open={openTermsAndConditions}
          onOk={() => setOpenTermsAndConditions(false)}
          okText="Accept"
          cancelText="Leave"
          width={{
            xs: "90%",
            sm: "80%",
            md: "70%",
            lg: "60%",
            xl: "50%",
            xxl: "40%",
          }}
          okButtonProps={{
            disabled: !(
              consentProductImprovement &&
              consentResearch &&
              consentAgeTerms &&
              consentExplicitFacial
            ),
          }}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <Button
                type="default"
                onClick={() => {
                  setConsentProductImprovement(true);
                  setConsentResearch(true);
                  setConsentMarketing(true);
                  setConsentAgeTerms(true);
                  setConsentExplicitFacial(true);
                }}
                style={{ marginRight: 8 }}
              >
                Agree to All
              </Button>
              <OkBtn />
            </>
          )}
        >
          <div style={{ marginBottom: 12 }}>
            <Checkbox
              checked={consentAgeTerms}
              onChange={(e) => setConsentAgeTerms(e.target.checked)}
              style={{ verticalAlign: "top" }}
            >
              I am at least 16 (or the digital age of consent in my country),
              and I have read and agree to the Terms of Use and Privacy Notice.
            </Checkbox>
          </div>
          <div style={{ marginBottom: 12 }}>
            <Checkbox
              checked={consentExplicitFacial}
              onChange={(e) => setConsentExplicitFacial(e.target.checked)}
              style={{ verticalAlign: "top" }}
            >
              Explicit consent to process my facial video & survey data (GDPR
              Art. 9(2)(a)) I give explicit consent for [Company legal name] to
              process my facial video and survey answers—which may include
              health‑related information—using automated AI analysis to generate
              my personal skin insights. I understand I can withdraw consent at
              any time without affecting past lawful processing.
            </Checkbox>
          </div>
          <div style={{ marginBottom: 12 }}>
            <Checkbox
              checked={consentProductImprovement}
              onChange={(e) => setConsentProductImprovement(e.target.checked)}
              style={{ verticalAlign: "top" }}
            >
              I consent to the use of my video and derived features for product
              improvement and AI model training. Where possible we will use
              pseudonymised/aggregated data. I can withdraw this consent at any
              time.
            </Checkbox>
          </div>
          <div style={{ marginBottom: 12 }}>
            <Checkbox
              checked={consentResearch}
              onChange={(e) => setConsentResearch(e.target.checked)}
              style={{ verticalAlign: "top" }}
            >
              Research participation (de‑identified): I consent to my
              de‑identified data being used in scientific research or published
              statistics. No public results will identify me personally.
            </Checkbox>
          </div>
          <div style={{ marginBottom: 12 }}>
            <Checkbox
              checked={consentMarketing}
              onChange={(e) => setConsentMarketing(e.target.checked)}
              style={{ verticalAlign: "top" }}
            >
              Marketing: I agree to receive product updates, offers, and tips by
              email or push notifications. I can opt out at any time.
            </Checkbox>
          </div>
        </Modal>
        <CameraInstructionsModal
          visible={showCameraInstructions}
          onClose={() => setShowCameraInstructions(false)}
          onContinue={() => {
            setFaceCameraMode(pendingCameraMode);
            setFaceCameraDrawerVisible(true);
          }}
          isVideo={pendingCameraMode === "video"}
        />
      </FullScreeen>
    );
}

export default PatientSurveySubmitShareNewDesign;
